module.exports = __webpack_public_path__ + "static/media/QRCode.a4ffa4ba.svg";